import { PackageDisplayData } from "@capone/packages-api";
import * as actionTypes from "./constants";

export interface ISetSearchKey {
  type: actionTypes.SET_SEARCH_KEY;
  searchKey: string | null;
}

export const setSearchKey = (searchKey: string | null): ISetSearchKey => ({
  type: actionTypes.SET_SEARCH_KEY,
  searchKey,
});

export interface ISetPackageDisplayData {
  type: actionTypes.SET_PACKAGE_DISPLAY_DATA;
  searchKey: string;
  data: PackageDisplayData;
}

export const setPackageDisplayData = (
  searchKey: string,
  data: PackageDisplayData,
): ISetPackageDisplayData => ({
  type: actionTypes.SET_PACKAGE_DISPLAY_DATA,
  searchKey,
  data,
});

/**
 * Tracks whether `pollPackageVersion` has ever been triggered and whether it has
 * finished. "idle" = never started; "polling" = in flight; "settled" = finished
 * (whether it succeeded, exhausted its retries, or returned immediately because no
 * target version was given). Consumers (Review/Book's redirect-decision gates) use
 * this to tell "still loading" apart from "loaded and genuinely empty" — `data`
 * alone can't make that distinction before the first poll completes.
 */
export type PackagePollState = "idle" | "polling" | "settled";

export interface ISetPackagePollState {
  type: actionTypes.SET_PACKAGE_POLL_STATE;
  pollState: PackagePollState;
}

export const setPackagePollState = (
  pollState: PackagePollState,
): ISetPackagePollState => ({
  type: actionTypes.SET_PACKAGE_POLL_STATE,
  pollState,
});

export type PackageIdentityActions =
  | ISetSearchKey
  | ISetPackageDisplayData
  | ISetPackagePollState;
